import Store from '../../features/store/layouts/store';

export default function StorePage() {
    return <Store />;
}
